import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import Tooltip from "@ats/src/components/shared/Tooltip";
import Icon from "@ats/src/components/shared/Icon";

interface Props {
  size?: "small" | "medium";
  className?: string;
}

const TOOLTIP_LABEL =
  "Candidates who choose this answer pass. You can filter job applications by pass or fail.";

function PassingAnswerTag({ size = "medium", className }: Props) {
  return (
    <Tooltip label={TOOLTIP_LABEL}>
      <Styled.Tag size={size} className={className} tabIndex={0}>
        Passing answer
        <Icon name="info" />
      </Styled.Tag>
    </Tooltip>
  );
}

export default PassingAnswerTag;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Tag = styled.span((props: any) => {
  const t: any = props.theme;
  const { size } = props;
  return css`
    label: PassingAnswerTag;
    ${t.rounded.xs}
    padding: ${size === "small" ? "0.25rem 0.375rem" : "0.1875rem 0.5rem"};
    font-size: ${size === "small" ? "0.6875rem" : "0.75rem"};
    font-weight: 450;
    line-height: 1;
    border: 1px solid ${t.dark ? t.color.gray[600] : t.color.gray[300]};
    background: ${t.dark ? t.color.gray[700] : t.color.gray[100]};
    color: ${t.dark ? t.color.gray[200] : t.color.black};
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    white-space: nowrap;
    flex-shrink: 0;
    cursor: default;
    user-select: none;

    svg {
      ${t.ml(1)}
      width: 0.75rem;
      height: 0.75rem;
      color: ${t.dark ? t.color.gray[400] : t.color.gray[600]};
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px ${t.dark ? t.color.gray[500] : t.color.gray[300]};
    }
  `;
});
